module.exports = {
  "zones": {
    "Africa/Windhoek": ["z", {
      "wallclock": 637977600000,
      "format": "%s",
      "abbrev": "CAT",
      "offset": 7200000,
      "posix": 637970400000,
      "save": 0,
      "rules": "Namibia"
    }, {
      "wallclock": -845244000000,
      "format": "SAST",
      "abbrev": "SAST",
      "offset": 7200000,
      "posix": -845254800000,
      "save": 0
    }, {
      "wallclock": -860968800000,
      "format": "SAST",
      "abbrev": "SAST",
      "offset": 7200000,
      "posix": -860976000000,
      "save": 3600000
    }, {
      "wallclock": -2109283200000,
      "format": "SAST",
      "abbrev": "SAST",
      "offset": 7200000,
      "posix": -2109288600000,
      "save": 0
    }, {
      "wallclock": -2458166400000,
      "format": "+0130",
      "abbrev": "+0130",
      "offset": 5400000,
      "posix": -2458170504000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 4104000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Namibia": [{
      "from": 1994,
      "to": 2017,
      "month": 8,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "CAT",
      "saved": -3600000
    }, {
      "from": 1995,
      "to": 2017,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": -60,
      "letter": "WAT",
      "saved": 0
    }, {
      "from": 1994,
      "to": 1994,
      "month": 2,
      "day": [7, 21],
      "time": 0,
      "clock": "wallclock",
      "save": -60,
      "letter": "WAT",
      "saved": 0
    }]
  }
};